module.exports = __webpack_public_path__ + "assets/img/logo.b23101ee.svg";